/*

Redux Form render function for DatePicker component.

https://material-ui-pickers.dev/api/DatePicker

 */

import React from 'react';
import moment from 'moment';
import {DatePicker} from "@material-ui/pickers";
import TextField from '@material-ui/core/TextField';

const renderDateOfBirth = ({
    input: {value, onBlur, ...inputProps},
    meta: {touched, invalid, error},
    variant,
    label,
    placeholder,
    helperText,
    fullWidth,
    DatePickerProps,
    InputProps,
}) => {
    const onChange = date => {
        Date.parse(date) ? inputProps.onChange(moment(date).format('YYYY-MM-DD')) : inputProps.onChange(null);
    };
    const renderTextField = (props) => (
        <TextField
            {...props}
            error={(touched && invalid) || Boolean(error || error)}
            helperText={(touched && error) || helperText}
            // helperText={(invalid && error) || helperText}
            label={label}
            placeholder={placeholder}
            variant={variant}
            fullWidth={fullWidth}
            inputProps={{
                ...props.inputProps,
                ...inputProps,
            }}
            InputProps={{
                ...props.InputProps,
                ...InputProps,
            }}
        />
    );
    return (
        <DatePicker
            autoOk
            openTo="year"
            format="YYYY-MM-DD"
            variant="dialog"
            views={["year", "month", "date"]}
            value={value}
            onChange={onChange}
            TextFieldComponent={renderTextField}
            {...DatePickerProps}
        />
    );
};

export default renderDateOfBirth;